module.exports = __webpack_public_path__ + "img/spruitjes-met-gochujangsaus.c3d3814e.jpg";